import React, { useEffect, useState } from 'react';
import { getFollowers } from './ApiCalls';

export default function Followers(user) {
  const [followers, setfollowers] = useState([]);

  useEffect(() =>{
    getFollowers(user.username).then((events) => {
      if(events.message !== 'Not Found')
      setfollowers(events);
      else
      setfollowers([])
    });
  }, [user.username]);

  function changeUser(event, username){
    event.preventDefault();
    user.setUser(username);
  }

  return(
    <div className='center follow-gap flex'>
      {followers.map((follower) => (
        <div className='follow-border' key={follower.login}>
          <img className={follower.type ==='Organization'? 'follow-img enterprise-img' : 'follow-img'} src={follower.avatar_url} alt='GitHub user profile'></img>
          <p className='sub-color padding-bottom10'>{follower.login}</p>
          <div className='center'>
            <a href={follower.html_url} target="_blank" rel="noreferrer">
              <button className='button-repo' onClick={(event) => changeUser(event, follower.login)}>Learn More</button>
            </a>
            <a href={follower.html_url} target="_blank" rel="noreferrer">
              <button className='button-repo'>Visit GitHub</button>
          </a>
          </div>
        </div>
      ))}
    </div>      
  )
} 
